/**
 * Where the person is signed in (Settings → Security). Drew, 2026-11-04: "show
 * active logins, and then close all but current session … real app stuff."
 *
 * The list comes from get_my_sessions() (20261104000002), which reads only the
 * caller's own rows. Signing out uses Supabase's own scopes: 'others' ends every
 * login but this one; useAuth's signOutEverywhere ('global') ends them all, and
 * the sidebar's Sign Out ('local') ends only this device.
 * Supabase cannot cancel a login token already handed out, so another device
 * stops at its next renewal, within the hour; Suspend in the Admin Panel is the
 * way to cut someone off at once.
 */
import { supabase } from '@/lib/safeSupabase';

export interface MySession {
  id: string;
  created_at: string;
  last_active_at: string;
  user_agent: string | null;
  ip: string | null;
  is_current: boolean;
}

export async function loadMySessions(): Promise<MySession[]> {
  const { data, error } = await supabase.rpc('get_my_sessions' as never);
  if (error) throw error;
  return (data ?? []) as unknown as MySession[];
}

export async function signOutOtherDevices(): Promise<void> {
  const { error } = await supabase.auth.signOut({ scope: 'others' });
  if (error) throw error;
}
